import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import classnames from 'classnames'
import styled from 'styled-components'
import shortid from 'shortid'
import {
  CustomInput,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'
import Select from 'react-select'
import moment from '../../lib/moment.js'
import { status, url, customStyles, sequence } from '../../constants'

class LeaveEntitlementForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
    }
  }
  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={ classnames({ active: this.state.activeTab === '1' }) }
              onClick={ () => {} }
            >
              Leave Entitlement Information
            </NavLink>
          </NavItem>
          <Image
            src={ url }
            onClick={ get(this.props, 'create') ? this.props.cancelForm : this.props.showDiscard }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <EntitlementForm onSubmit={ (e) => e.preventDefault() }>
                  <FormGroup>
                    <Container >
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Start Date</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputFieldDate
                            autoComplete='off'
                            name="start_date"
                            type="date"
                            disabled={ get(this.props, 'create') === undefined }
                            value={ moment(get(this.props, 'start_date')).format('YYYY-MM-DD') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >End Date</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputFieldDate
                            autoComplete='off'
                            name="end_date"
                            type="date"
                            disabled={ get(this.props, 'create') === undefined }
                            value={ moment(get(this.props, 'end_date')).format('YYYY-MM-DD') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Leave Entitlement ID</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="leave_entitlement_code"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Leave Entitlement ID"
                            value={ get(this.props, 'leave_entitlement_code') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Leave Entitlement Name</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="name"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Leave Entitlement Name"
                            value={ get(this.props, 'name') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Leave Type ID</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <SelectInputField
                            styles={ customStyles }
                            name="leave_type_id"
                            isDisabled={ get(this.props, 'create') === undefined }
                            placeholder="Enter Leave Type ID"
                            value={ get(this.props, 'leave_type_id') }
                            options={ get(this.props, 'leaveTypeList') }
                            onChange={ this.props.handleLeaveType }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Entitlement Total Default</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="leave_total_default"
                            type='number'
                            disabled={ get(this.props, 'create') === undefined }
                            placeholder="Enter Entitlement Total Default"
                            value={ get(this.props, 'leave_total_default') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label>Deduct Sequence</Label></Col>
                        <Col sm={ 9 }>
                          <CustomInputField
                            type="select"
                            id="sequence"
                            name="sequence"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            value={ get(this.props, 'sequence') }
                            onChange={ this.props.handleInput }
                          >
                            {
                              sequence.map((s) => <option key={ shortid() } value={ s.value }>{ s.label }</option>)
                            }
                          </CustomInputField>
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label /></Col>
                        <Col sm={ 9 }>
                          <CustomInput
                            type="checkbox"
                            name="is_prorate"
                            id="is_prorate"
                            label="Prorate"
                            disabled={ get(this.props, 'create') === undefined }
                            checked={ get(this.props, 'is_prorate') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      {
                        get(this.props, 'create') === undefined &&
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }><Label>Status</Label></Col>
                          <Col sm={ 9 }>
                            <CustomInputField
                              type="select"
                              id="is_active"
                              name="is_active"
                              disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                              value={ get(this.props, 'is_active') }
                              onChange={ this.props.handleInput }
                            >
                              {
                                status.map((s) => <option key={ shortid() } value={ s.value }>{ s.label }</option>)
                              }
                            </CustomInputField>
                          </Col>
                        </Row>
                      }
                      {
                        get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }><Label>Modified Date</Label></Col>
                            <Col sm={ 9 }>
                              <p>{ get(this.props, 'updated') ? moment(get(this.props, 'updated')).format('DD/MM/YYYY') : '-' }</p>
                            </Col>
                          </Row>
                      }
                      {
                        get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }><Label>Modified By</Label></Col>
                            <Col sm={ 9 }>
                              <p>{ get(this.props, 'updated_by') ? get(this.props, 'updated_by') : '-' }</p>
                            </Col>
                          </Row>
                      }
                    </Container>
                  </FormGroup>
                  <Right>
                    { get(this.props, 'button') }
                  </Right>
                </EntitlementForm>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}
LeaveEntitlementForm.propTypes = {
  handleInput: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
export default LeaveEntitlementForm

const EntitlementForm = styled.div`
  overflow-y: scroll;
  max-height: calc(100vh - 220px);
`

const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`
const Background = styled.div`
  background-color: white;
  padding: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const InputField = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`
const InputFieldDate = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
    float: right;
    ::-webkit-inner-spin-button {
      display: none;
      -webkit-appearance: none;
    }
 `
const Image = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px;
`
const CustomInputField = styled(CustomInput)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`
const SelectInputField = styled(Select)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`



// WEBPACK FOOTER //
// ./src/components/leave-entitlement/index.js